/**
 * Parsing methods.
 * @module parse
 */
define(function(require, exports, module) {

    'use strict';

    exports.showOtpWindow = function (callback, failureCallBack) {
        if(window.cxp && window.cxp.mobile) {
            var plugin = cxp.mobile.plugins['DigiPass'];
            if (plugin) {
                //the param "data" can be checked according to the return response of the plugin
                plugin.generateOTP(function (data) {
                    callback(data);
                }, function(error){
                    failureCallBack(error);
                });
            }
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/modules/utils/mobile-otp-window.js
// module id = 41
// module chunks = 0